import { render, staticRenderFns } from "./Tab_event.vue?vue&type=template&id=7c25c350"
import script from "./Tab_event.vue?vue&type=script&lang=js"
export * from "./Tab_event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports